export const RESET = 'RESET'
export const START_LOADING = 'START_LOADING'
export const CLOSE_LOADING = 'CLOSE_LOADING'

export const SET_ACTIVE = 'SET_ACTIVE'
export const UPDATE_CART = 'UPDATE_CART'


// WEBPACK FOOTER //
// ./src/redux/action.js